import {ParameterValidator} from '@mvps-genesis/utilities';
import EventBus from '@mvps-genesis/event-bus';

export default class EmailInvoice {

	constructor () {

		// Create validator
		this.validator = new ParameterValidator(this);

		this.elements = {
			form: this.validator.isElement('form', '#js-email-invoice-form', {required: false}),
			messages: this.validator.isElement('messages', '#js-email-invoice-messages', {required: false})
		};

		this.bindEvents();
	}

	bindEvents () {
		const self = this;

		EventBus.addEventListener('MiniModal:onShow', function (e) {
			self.modalOnShow(e);
		});

		if (this.elements.form) {
			this.elements.form.addEventListener('submit', (e) => this.formSubmission(e), false);
		}
	}

	modalOnShow (e) {
		if (e.detail.id !== 'modal-email-invoice') {
			return false;
		}

		this.reset();

		return true;
	}

	async formSubmission (e) {
		e.preventDefault();

		this.elements.messages.innerHTML = '';
		this.disableInputs();

		const response = await this.sendRequest();

		this.enableInputs();

		return this.handleResponse(response);
	}

	async sendRequest () {

		const response = await fetch(this.elements.form.action, {
			body: JSON.stringify({
				Function: 'EMAIL_ORDER_EMAIL',
				Order_ID: this.elements.form.elements.Order_ID.value,
				To_Email: this.elements.form.elements.Email_To.value
			}),
			method: 'POST'
		});

		if (!response.ok) {
			this.enableInputs();
			throw new Error('Network response was not successful');
		}

		return response.json();
	}

	disableInputs () {
		const inputs = this.elements.form.querySelectorAll('input');

		for (const input of inputs) {
			input.disabled = true;

			if (input.type === 'submit') {
				input.setAttribute('data-original-text', input.value);
				input.value = 'Sending...';
			}
		}
	}

	enableInputs () {
		const inputs = this.elements.form.querySelectorAll('input, button');

		for (const input of inputs) {
			input.disabled = false;

			if (input.type === 'submit') {
				input.value = input.getAttribute('data-original-text');
			}
		}
	}

	handleResponse (response) {
		let html = '';

		if (response.success === 0) {
			html = `
				<p class="x-messages x-messages--error">${response.message}</p>
			`;
		} else {
			html = `
				<p class="x-messages x-messages--success">Your Invoice has been sent!</p>
			`;

			this.elements.form.reset();

			setTimeout(() => {
				this.elements.messages.innerHTML = '';
			}, 3000);
		}

		this.elements.messages.innerHTML = html;
	}

	reset () {
		this.elements.form.reset();

		this.elements.messages.innerHTML = '';
	}
}
